import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { Image } from 'foundations-components/transitional/components/Image';
// @ts-expect-error untyped dependency
import providerSignupImageUrl from 'bender-url!marketplace-assets-base/img/provider-signup/community-creators-image.png';
import { MediaQueryView } from 'marketplace-ui-common/layout/components/MediaQueryView';
import { getPublicAssetProviderSignupUrl } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ProviderSignupBanner({
  onTrackInteraction
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    overflow: "hidden",
    children: [/*#__PURE__*/_jsxs(Flex, {
      padding: "1000",
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        typography: "heading-600",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.templates.providerSignupCTA.title"
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: "heading-400",
        paddingBlock: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.templates.providerSignupCTA.subtitle"
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          width: '200px'
        },
        children: /*#__PURE__*/_jsx(Button, {
          marginBlockStart: "400",
          onClick: () => {
            onTrackInteraction('click provider signup');
          },
          href: getPublicAssetProviderSignupUrl(),
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.templates.providerSignupCTA.button"
          })
        })
      })]
    }), /*#__PURE__*/_jsx(MediaQueryView, {
      min: "md",
      children: /*#__PURE__*/_jsx(Image, {
        blockSize: "300px",
        responsive: false,
        src: providerSignupImageUrl,
        role: "presentation"
      })
    })]
  });
}